<template>
  <div class="w-full h-full flex flex-col">
    <div class="flex items-center justify-between mr-5">
      <div class="flex justify-center items-center font-500">
        <div class="text-primary text-14 font-600 h-12 flex items-center cursor-pointer ml-3" @click="onBack">{{ $t('navigation.flows') }}</div>
        <span class="ml-2 mr-0 text-gray-400">></span>
        <span class="ml-2 text-semi-dark-text text-14 font-600">{{ agentName }}</span>
        <span class="ml-2 text-10 font-600 px-1.5 py-0.5 rounded-4 bg-purple-100 text-purple-700">Agent</span>
      </div>
      <div class="ml-auto">
        <PillButton :text="$t('edit')" primary icon="edit" @click="onEdit" />
      </div>
    </div>

    <template v-if="loading">
      <div class="flex-grow flex items-center justify-center text-gray-500 text-14">
        <Icon name="loading_dots" class="w-14 text-primary" />
      </div>
    </template>
    <template v-else-if="agentData">
      <div class="flex-grow overflow-hidden mt-1">
        <AgentDesigner :agent="agentData" />
      </div>
    </template>
    <template v-else>
      <div class="flex-grow flex items-center justify-center text-gray-400 text-13">Failed to load agent configuration.</div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import AgentDesigner from '@/components/flow/agent-designer/AgentDesigner.vue';
import AgentEditorModal from '@/components/flow/AgentEditorModal.vue';

export default {
  name: 'AgentDesignerView',
  components: { AgentDesigner },
  data() {
    return {
      loading: false,
      agentData: null,
      agentName: '',
    };
  },
  computed: {
    ...mapState(['selectedIntentDefinition', 'bootstrapped']),
    projectId() {
      return this.$route.params.projectId;
    },
    flowId() {
      return this.$route.params.flowId;
    },
  },
  methods: {
    ...mapActions(['fetchProjectFlow', 'showToastMessage']),
    ...mapMutations(['SET_SELECTED_INTENT_DEFINITION']),
    onBack() {
      this.$router.push({ name: 'project-flows', params: { projectId: this.projectId } });
    },
    loadFromDefinition() {
      const def = this.selectedIntentDefinition;
      if (def && def.agent) {
        // The agent payload has no display name; the flow definition carries it.
        this.agentData = { ...JSON.parse(JSON.stringify(def.agent)), name: def.name || '' };
        this.agentName = def.name || '';
      } else {
        this.agentData = null;
      }
    },
    onEdit() {
      this.$showModal(
        AgentEditorModal,
        { flowId: this.flowId, projectId: this.projectId },
        // Reload when the editor reports a successful save so the designer reflects edits.
        { saved: () => this.reload() },
      );
    },
    async reload() {
      this.loading = true;
      try {
        await this.fetchProjectFlow({ projectId: this.projectId, flowId: this.flowId });
        this.loadFromDefinition();
      } catch (e) {
        this.showToastMessage({ title: 'Failed to load agent', type: 'error' });
        this.agentData = null;
      }
      this.loading = false;
    },
  },
  watch: {
    bootstrapped: {
      handler() {
        if (this.bootstrapped && this.flowId) this.reload();
      },
      immediate: true,
    },
    flowId() {
      if (this.bootstrapped && this.flowId) this.reload();
    },
  },
  beforeUnmount() {
    this.SET_SELECTED_INTENT_DEFINITION(null);
  },
};
</script>
